import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./Homepage"),{
		fallback: <div>Loading...</div>
	})
};
